import React, { useState } from 'react';
import { Icon } from 'antd';

import { SETTINGS } from '../../config/media';
import Wrapper from './style';

const displayIcons = (type) => {
    if (type === 'warning') {
        return (
            <Icon
                type="clock-circle"
                className="icon"
                theme="filled"
                // style={{ color: '#F28041' }}
            />
        );
    } else if (type === 'settings') {
        return (<img src={SETTINGS} alt="settings" className="icon" />);
    } else {
        return (<Icon type="check-circle" theme="filled" className="icon" />);
    }
};

const IconToolTip = ({ type = '', tip, animation = true, onClick = () => {} }) => {
    const [showTip, setTipVisible] = useState(false);
    return (
        <Wrapper
            className={type}
            onMouseEnter={() => setTipVisible(true)}
            onMouseLeave={() => setTipVisible(false)}
            onClick={onClick}
        >
            <div className={ showTip && animation ? "tip-icon tip-icon-show" : "tip-icon"}>
                {displayIcons(type)}
            </div>
            {showTip && tip
                ? <span>{tip}</span>
                : null
            }
        </Wrapper>
    )
}

export default IconToolTip;
